import React, { useState } from "react"
import styled from "styled-components"
import parsePhoneNumber from "libphonenumber-js"

import NextImg from "@/common/components/NextImg"
import PopupButton from "./PopupButton"
import DownloadDeepLink from "@/common/assets/image/lucky-bag-2023/button-DeepLink-W.svg"
import PhoneInput from "react-phone-input-2"
import { CopyToClipboard } from "react-copy-to-clipboard"
import "react-phone-input-2/lib/material.css"
import { theme } from "./mixin"

export default function PopupGetNFT({
  setShowPanel,
  showResult,
  setShowResult,
  isLoading,
  receiveErrorCode,
  handleClick,
  txHash,
  swichToShare,
  walletIdToken,
  savePhoneNumber,
  setSavePhoneNumber
}) {
  const [phoneNumber, setPhoneNumber] = useState()
  const [check, setCheck] = useState(false)
  const [initialCountryCode, setInitialCountryCode] = useState("tw")
  const [copy1, setCopy1] = useState(false)

  const resetNFT = () => {
    setShowResult(null)
    setPhoneNumber()
    setCheck(false)
  }

  const getErrorDisplay = code => {
    switch (code) {
      case 4006:
        return "領過了"
      case 4008:
        return "系統忙碌中，請稍後再試"

      case 4010:
        return "電話號碼格式錯誤"
      case 4014:
        return "已經領取完畢，感謝參與"

      default:
        return "系統忙碌中，請稍後再試"
    }
  }

  // 電話號碼輸入
  const handleChange = value => {
    setPhoneNumber(value)
    setSavePhoneNumber(value)
  }
  // 這邊是判斷電話號碼是否正確
  const isValidPhoneNumber = phoneNumber => {
    return parsePhoneNumber(`+${phoneNumber}`)?.isValid()
  }
  // 根據電話號碼還有同意隱私權 去判斷按鈕的樣式
  const getButtonState = (phoneNumber, check) => {
    if (!isValidPhoneNumber(phoneNumber) || !check) return "disabled"

    return ""
  }
  // 這邊是送出NFT的按鈕
  const getNFTClick = () => {
    // if (!isValidPhoneNumber(phoneNumber) || !check) return
    handleClick(null, phoneNumber)
  }
  // 這邊是領取後 加密電話號碼
  const getHiddenPhoneDisplay = phoneNumber => {
    let _phoneShow = phoneNumber?.replace(/^(\d{3})\d{5}(\d+)/, "$1*****$2")
    return _phoneShow
  }
  return (
    <Wrapper>
      <TitleWrapper>領取NFT禮物盒</TitleWrapper>
      {!showResult ? (
        <>
          <h3>輸入手機號碼</h3>
          <p>NFT 將透過 KryptOGO Wallet 空投！</p>
          <FormWrapper>
            <PhoneInput
              autoFormat
              countryCodeEditable={false}
              country={initialCountryCode}
              onlyCountries={["tw", "us"]}
              placeholder="090-000-0000"
              required
              onChange={handleChange}
            />

            <CheckWrapper>
              <label className="container">
                <p>我已經閱讀並同意</p>
                <input
                  type="checkbox"
                  value="confirm"
                  onChange={() => setCheck(!check)}
                />
                <span className="checkmark"></span>
                <a href="">隱私權政策</a>
              </label>
            </CheckWrapper>
            <ButtonWrapper>
              <PopupButton
                type={getButtonState(phoneNumber, check)}
                title="送出"
                onClick={getNFTClick}
                id="toybox-PopupMainButton"
              />
            </ButtonWrapper>
          </FormWrapper>
        </>
      ) : (
        <>
          {(!receiveErrorCode || receiveErrorCode === 4006) && (
            <>
              {receiveErrorCode === 4006 ? (
                <h3>您已經領取過</h3>
              ) : (
                <>
                  <h3>已經發送至</h3>{" "}
                  {walletIdToken ? (
                    <h3>您的 KryptoGO Wallet</h3>
                  ) : (
                    <h3>+{getHiddenPhoneDisplay(savePhoneNumber)}</h3>
                  )}
                </>
              )}

              <p>下載 KryptoGO 立刻查看 NFT</p>
              <DownloadsWrapper>
                <a
                  href="https://kryptogo.page.link/q9gD"
                  target="blank"
                  id="toybox-PopupDownloadButton"
                >
                  <DownloadButtonWrapper>
                    <NextImg src={DownloadDeepLink} />
                  </DownloadButtonWrapper>
                </a>
                <CopyToClipboard
                  onCopy={() => {
                    setCopy1(true)
                    setTimeout(() => {
                      setCopy1(false)
                    }, 800)
                  }}
                  text={`${
                    process.env.NEXT_PUBLIC_VERCEL_ENV === "production"
                      ? "https://www.kryptogo.com/"
                      : "https://www-dev.kryptogo.com/"
                  }nft-toy-box`}
                >
                  <DownloadButtonWrapper id="toybox-PopupShareButton">
                    <PopupButton copy={copy1} type="shareButton" />
                  </DownloadButtonWrapper>
                </CopyToClipboard>
              </DownloadsWrapper>

              <a
                style={{ zIndex: "3" }}
                target="blank"
                href={`https://polygonscan.com/tx/${txHash}`}
              >
                {"點擊查看NFT傳送狀態"}
              </a>
            </>
          )}
          {(receiveErrorCode === 4008 ||
            receiveErrorCode === 4010 ||
            receiveErrorCode === 4014) && (
            <>
              <h3>{getErrorDisplay(receiveErrorCode)}</h3>
              <BackButton
                onClick={() => {
                  setShowResult(false)
                  setShowPanel("close")
                  setPhoneNumber("")
                  setCheck(false)
                }}
              >
                <p>重新領取</p>
              </BackButton>
            </>
          )}
        </>
      )}
      {/* <p onClick={resetNFT}>重新</p> */}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  width: 100%;
  padding: 8px 30px;
  min-height: 200px;
  min-width: 330px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  * {
    margin: 0;
  }
  h3 {
    font-size: 20px;
    color: #19274b;
  }
  p {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #19274b;
    font-size: 16px;
  }
  a {
    color: #19274b;
    text-decoration: underline;
    cursor: pointer;
  }
`
const TitleWrapper = styled.h1`
  color: #19274b;
  font-size: 24px;
  margin-bottom: 12px;
`
const FormWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;

  .react-tel-input {
    position: relative;
    .special-label {
      display: none;
    }
    .form-control {
      padding: 16px 16px 16px 58px;
      width: 100%;
      background-color: rgba(255, 255, 255, 0);
      border: 1px solid #19274b;
      border-radius: 12px;
      color: #19274b;
      font-size: 16px;
      &::placeholder {
        color: #19274b;
        opacity: 0.8;
      }
    }
    .flag-dropdown {
      padding: 0;
      transform: translate(0%, -50%);
      top: 50%;
      left: 0;
      .country-list {
        width: 250px;
        .country-name {
          color: #000;
        }
      }
    }
    .selected-flag .arrow {
      border-top: #19274b 4px solid;
      &.up {
        border-top: #19274b 4px solid;
        border-bottom: none;
      }
      /* display: none; */
    }
  }
`

const ButtonWrapper = styled.div`
  width: 100%;
  margin: 20px 0 0;
`
const CheckWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  p {
    display: inline-block;
  }

  .container {
    display: block;
    position: relative;
    padding-left: 35px;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    padding-right: 0;
    user-select: none;
  }

  /* Hide the browser's default checkbox */
  .container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  /* Create a custom checkbox */
  .checkmark {
    position: absolute;
    top: 50%;
    left: 0;
    transform: translate(0, -50%);
    height: 16px;
    width: 16px;
    border: solid 1px #19274b;
  }

  .container input:checked ~ .checkmark {
    background-color: #19274b;
  }

  .checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }

  .container input:checked ~ .checkmark:after {
    display: block;
  }

  .container .checkmark:after {
    left: 5px;
    top: 2px;
    width: 5px;
    height: 10px;
    border: solid #ffffff;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }
`
const DownloadsWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: 20px 0;
  gap: 12px;
  width: 100%;
  max-width: 200px;
  a {
    width: 100%;
  }
`
const DownloadButtonWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 60px;
  border-radius: 100px;
  display: flex;
  align-items: center;
  transition: all 0.8s;
  color: ${theme.white};
  background-size: 300% 100%;
  background-position: 98% 0;
  background-image: ${theme.CTAcolorButton};
  border: 1px solid transparent;
  &:hover {
    background-position: 0% 0;
    transform: scale(1.05);
    box-shadow: 4px 4px 4px rgba(0, 0, 0, 0.03);
  }
  h3 {
    margin: 0;
  }
`

const BackButton = styled.div`
  width: 100%;
  margin-top: 20px;
  border: 1px solid #00fff0;
  padding: 16px;
  border-radius: 12px;
`

// const Wrapper = styled.div``
